<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardHeader>
          <h4>Πελάτες</h4>
          <CButton class="m-3" color="primary" @click="createClient()">Προσθήκη πελάτη</CButton>
        </CCardHeader>
        <CCardBody>
          <CModal
            class="modalAlert"
            :show.sync="alertIsShown"
            :centered="true"
            size="lg"
          >
            <CAlert
              closeButton
              :show.sync="alertIsShown"
              color="primary"
              fade
            >
              {{ message }}
            </CAlert>
          </CModal>
          <CDataTable
            :items="filteredItems"
            :fields="fields"
            :items-per-page="10"
            pagination
            column-filter
            table-filter
            hover
            striped
            :loading="loading"
            sorter
            @row-clicked="(item) => showClient(item.id)"
            clickable-rows
          >
          <template #afm="{item}">
            <td>
              {{ getAfmText(item.afm) }}
            </td>
          </template>
          <template #services-filter>
            <div class="selectFilter">
              <CSelect
                :options="servicesOptions"
                :value.sync="selectedOption"
              />
            </div>
          </template>
          <template #services="{item}">
            <td>
              {{ item.services }}
            </td>
          </template>
          <template #actions="{item}">
            <td class="button-cell">
              <CButton
                color="primary"
                class="btn-icon"
                @click.stop="editClient( item.id )"
                v-c-tooltip="'Επεξεργασία'"
              >
                <CIcon name="cilPencil" />
              </CButton>
            </td>
          </template>
        </CDataTable>
        </CCardBody>
      </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'

const fields = [
  {
    key: 'company', 
    label: 'Εταιρία', 
    sorter: true, 
    filter: true
  },
  {
    key: 'afm', 
    label: 'ΑΦΜ', 
    sorter: true, 
    filter: true
  },
  {
    key: 'services',
    label: 'Πρότυπα',
    sorter: true,
    filter: true
  },
  {
    key: 'actions',
    label: '',
    sorter: false,
    filter: false
  }
]

export default {
  name: 'Clients',
  data: () => {
    return {
      items: [],
      fields,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      you: null,
      message: '',
      selectedOption: 'Καμία επιλογή',
      servicesOptions: ['Καμία επιλογή'],
      loading: true,
      showMessage: false,
      dismissSecs: 7,
      alertIsShown: false,
      dismissCountDown: 0,
      showDismissibleAlert: false
    }
  },
  paginationProps: {
    align: 'center',
    doubleArrows: false,
    previousButtonHtml: 'prev',
    nextButtonHtml: 'next'
  },
  computed: {
    filteredItems() {
      if (this.selectedOption == "Καμία επιλογή") {
        return this.items;
      }
      return this.items.filter(item => {
        const services = item.services;

        return services.includes(this.selectedOption);
      })
    }
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    getAfmText (afm) {
      if (!afm) {
        return '-';
      } else {
        return afm;
      }
    },
    clientLink (id) {
      return `clients/${id.toString()}`
    },
    editLink (id) {
      return `clients/${id.toString()}/edit`
    },
    showClient ( id ) {
      const clientLink = this.clientLink( id );
      this.$router.push({path: clientLink});
    },
    editClient ( id ) {
      const editLink = this.editLink( id );
      this.$router.push({path: editLink});
    },
    // deleteClient ( id ) {
    //   let self = this;
    //   axios.post('/api/clients/' + id + '?token=' + localStorage.getItem("api_token"), {
    //     _method: 'DELETE'
    //   })
    //   .then(function (response) {
    //       self.message = 'Επιτυχής διαγραφή πελάτη.';
    //       self.showAlert();
    //       self.getClients();
    //   }).catch(function (error) {
    //     console.log(error);
    //     self.$router.push({ path: '/login' });
    //   });
    // },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    getServices (cases) {
      let serviceArray = cases.map((item) => {
        return item.name;
      });
      let services = serviceArray.join(", ");
      return services;
    },
    showAlert () {
      this.alertIsShown = true
    },
    getClients (){
      let self = this;
      axios.get('/api/clients?token=' + localStorage.getItem("api_token"))
      .then(function (response) {
        self.items = response.data.clients.map((item) => {
          item.services = self.getServices(item.services);
          return item;
        })

        self.loading = false;

          axios.get('/api/services/list?token=' + localStorage.getItem("api_token"))
          .then(function (response) {
            self.services = response.data;

            self.servicesOptions = ['Καμία επιλογή', ...self.services];

            self.selectedOption = self.servicesOptions[0];

          }).catch(function (error) {
            console.log(error);
            self.loading = false;
            self.$router.push({ path: '/login' });
          });

      }).catch(function (error) {
        console.log(error);
        self.loading = false;
        self.$router.push({ path: '/login' });
      });
    },
    createClient () {
      this.$router.push({path: 'clients/create'});
    },
  },
  mounted: function(){
    this.getClients();
  }
}
</script>

<style scoped>
/* Striped rows for better readability */
::v-deep tbody tr:nth-of-type(odd) {
  background-color: #f0f0f0 !important;
}

::v-deep tbody tr:nth-of-type(even) {
  background-color: #ffffff !important;
}

/* Hover effect for both odd and even rows */
::v-deep tbody tr:nth-of-type(odd):hover {
  background-color: #d0e8ff !important;
}

::v-deep tbody tr:nth-of-type(even):hover {
  background-color: #e3f2fd !important;
}
</style>
